export const usCities = [
  { value: "New York", label: "New York, NY" },
  { value: "Los Angeles", label: "Los Angeles, CA" },
  { value: "Chicago", label: "Chicago, IL" },
  { value: "Houston", label: "Houston, TX" },
  { value: "Phoenix", label: "Phoenix, AZ" },
  { value: "Philadelphia", label: "Philadelphia, PA" },
  { value: "San Antonio", label: "San Antonio, TX" },
  { value: "San Diego", label: "San Diego, CA" },
  { value: "Dallas", label: "Dallas, TX" },
  { value: "San Jose", label: "San Jose, CA" },
  { value: "Austin", label: "Austin, TX" },
  { value: "Jacksonville", label: "Jacksonville, FL" },
  { value: "San Francisco", label: "San Francisco, CA" },
  { value: "Columbus", label: "Columbus, OH" },
  { value: "Fort Worth", label: "Fort Worth, TX" },
  { value: "Charlotte", label: "Charlotte, NC" },
  { value: "Seattle", label: "Seattle, WA" },
  { value: "Denver", label: "Denver, CO" },
  { value: "Washington", label: "Washington, DC" },
  { value: "Boston", label: "Boston, MA" },
  { value: "El Paso", label: "El Paso, TX" },
  { value: "Detroit", label: "Detroit, MI" },
  { value: "Nashville", label: "Nashville, TN" },
  { value: "Portland", label: "Portland, OR" },
  { value: "Oklahoma City", label: "Oklahoma City, OK" },
  { value: "Las Vegas", label: "Las Vegas, NV" },
  { value: "Memphis", label: "Memphis, TN" },
  { value: "Louisville", label: "Louisville, KY" },
  { value: "Baltimore", label: "Baltimore, MD" },
  { value: "Milwaukee", label: "Milwaukee, WI" },
  { value: "Albuquerque", label: "Albuquerque, NM" },
  { value: "Tucson", label: "Tucson, AZ" },
  { value: "Fresno", label: "Fresno, CA" },
  { value: "Sacramento", label: "Sacramento, CA" },
  { value: "Kansas City", label: "Kansas City, MO" },
  { value: "Mesa", label: "Mesa, AZ" },
  { value: "Atlanta", label: "Atlanta, GA" },
  { value: "Omaha", label: "Omaha, NE" },
  { value: "Colorado Springs", label: "Colorado Springs, CO" },
  { value: "Raleigh", label: "Raleigh, NC" },
  { value: "Virginia Beach", label: "Virginia Beach, VA" },
  { value: "Miami", label: "Miami, FL" },
  { value: "Oakland", label: "Oakland, CA" },
  { value: "Minneapolis", label: "Minneapolis, MN" },
  { value: "Tulsa", label: "Tulsa, OK" },
  { value: "Cleveland", label: "Cleveland, OH" },
  { value: "Wichita", label: "Wichita, KS" },
  { value: "Arlington", label: "Arlington, TX" },
  { value: "New Orleans", label: "New Orleans, LA" },
  { value: "Tampa", label: "Tampa, FL" },
  { value: "Honolulu", label: "Honolulu, HI" }
];

export const canadaCities = [
  { value: "Toronto", label: "Toronto, ON" },
  { value: "Montreal", label: "Montreal, QC" },
  { value: "Calgary", label: "Calgary, AB" },
  { value: "Ottawa", label: "Ottawa, ON" },
  { value: "Edmonton", label: "Edmonton, AB" },
  { value: "Winnipeg", label: "Winnipeg, MB" },
  { value: "Vancouver", label: "Vancouver, BC" },
  { value: "Quebec City", label: "Quebec City, QC" },
  { value: "Hamilton", label: "Hamilton, ON" },
  { value: "Kitchener", label: "Kitchener, ON" },
  { value: "London", label: "London, ON" },
  { value: "Halifax", label: "Halifax, NS" },
  { value: "Victoria", label: "Victoria, GC" },
  { value: "Windsor", label: "Windsor, ON" },
  { value: "Saskatoon", label: "Saskatoon, SK" },
  { value: "Regina", label: "Regina, SK" },
  { value: "Sherbrooke", label: "Sherbrooke, QC" },
  { value: "St. John's", label: "St. John's, NL" },
  { value: "Barrie", label: "Barrie, ON" },
  { value: "Kelowna", label: "Kelowna, BC" },
  { value: "Abbotsford", label: "Abbotsford, BC" },
  { value: "Sudbury", label: "Sudbury, ON" },
  { value: "Kingston", label: "Kingston, ON" },
  { value: "Saguenay", label: "Saguenay, QC" },
  { value: "Trois-Rivieres", label: "Trois-Rivieres, QC" },
  { value: "Guelph", label: "Guelph, ON" },
  { value: "Cambridge", label: "Cambridge, ON" },
  { value: "Thunder Bay", label: "Thunder Bay, ON" },
  { value: "Saint John", label: "Saint John, NB" },
  { value: "Waterloo", label: "Waterloo, ON" }
];

